import React from "react";
import styles from "./PrivacyPolicy.module.css";


export default function PrivacyPolicy() {
    return (
        <div className={styles.privacyContainer}>
            <h1 style={{textAlign:'center'}}>Privacy Policy</h1>
            


            <h4>Information We Collect</h4>
            <p>We may collect device type, IP address, operating system, app usage data, and government-issued ID numbers for booking verification. Guests must also present a valid government-issued ID at hotel check-in.</p>


            <h4>How We Use Your Information</h4>
            <p>We use your information to facilitate and confirm hotel bookings, process secure payments, provide customer support, comply with legal obligations, and improve user experience and app performance.</p>


            <h4>Data Sharing & Disclosure</h4>
            <p>We do not sell or rent your personal data. Your data may be shared with authorized government departments, hotel property managers, payment gateways, and legal authorities when required by law.</p>


            <h4>Data Storage and Security</h4>
            <p>Your data is stored securely on government-approved servers with encryption and access controls. We apply physical, electronic, and managerial safeguards to protect your information.</p>


            <h4>User Rights</h4>
            <p>You have the right to view the personal data we store, request corrections, and request deletion subject to legal and operational constraints. To exercise these rights, contact us at jtdcltd@gmail.com.</p>


            <h4>Cookies and Tracking</h4>
            <p>We may use limited analytics and session cookies to improve usability. These cookies do not collect personal information.</p>


            <h4>Updates to This Policy</h4>
            <p>This Privacy Policy may be updated periodically. Users will be notified through the website or app.</p>


            <h4>Contact Information</h4>
            <p>
                Jharkhand Tourism Development Corporation Ltd.<br />
                Email: jtdcltd@gmail.com<br />
                Phone: +91 9102403884
            </p>
        </div>
    );
}